// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon_icon__kRWTo","animate":"icon_animate__ggCuw","spin":"icon_spin__vzDNJ"};